var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSymbolDpdRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 40,
    viewBox: "0 0 35 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Cube/symbolDpdRed"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_491_1828",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "boundingBox",
    x: 0.317627,
    width: 34,
    height: 40,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_491_1828)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "primaryCubeBlack",
    d: "M33.3441 8.66053L32.875 8.95838C29.4714 10.9596 26.077 12.9701 22.6642 14.962C22.259 15.1465 22.0201 15.577 22.0754 16.0231C22.1398 17.2145 22.0754 17.0656 23.0505 17.6799C23.3965 17.9536 23.879 17.9649 24.2372 17.7078C27.3648 15.8463 30.5108 13.9847 33.6385 12.1231L34.2088 11.7973C34.2157 11.9275 34.2157 12.058 34.2088 12.1882V29.2311C34.221 29.8094 33.897 30.3412 33.3809 30.59L22.8022 36.9287C21.2659 37.8595 19.7205 38.7903 18.2027 39.7211C17.6646 40.093 16.9562 40.093 16.4181 39.7211C11.3587 36.6681 6.29933 33.6399 1.23993 30.6366C0.645189 30.3315 0.284434 29.7 0.320041 29.0263C0.320041 23.4415 0.320041 17.8847 0.320041 12.3558C0.320041 12.1882 0.320041 12.03 0.320041 11.7973L0.825981 12.0765L15.2223 20.5468C15.5501 20.6911 15.7475 21.034 15.7098 21.3938C15.7098 25.5265 15.7098 29.6499 15.7098 33.7827V34.2015C15.6978 34.4774 15.8499 34.7339 16.0962 34.8531L16.8689 35.2905C17.112 35.4396 17.4168 35.4396 17.66 35.2905L18.3959 34.881C18.661 34.766 18.824 34.4925 18.8006 34.2015C18.8006 34.0898 18.8006 33.9781 18.8006 33.8664V19.8301C18.8006 19.6997 18.8006 19.5787 18.8006 19.4484C18.8094 19.193 18.6739 18.9547 18.4511 18.8341L17.2828 18.1453L1.71828 8.95838L1.23993 8.66984L1.62629 8.39991L16.3445 0.264765C16.9082 -0.088255 17.6207 -0.088255 18.1843 0.264765C23.1057 3.0013 28.0087 5.6913 32.9118 8.39991L33.3441 8.66053Z",
    fill: "#DC0032"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolDpdRed);
export default __webpack_public_path__ + "static/media/symbolDpdRed.071cf6c2d43caa0bf07cc0d2210ddd1a.svg";
export { ForwardRef as ReactComponent };